import React, { useState } from "react";
import {
    Box,
    Card,
    CardMedia,
    CardContent,
    Typography,
    Button,
    IconButton,
    Chip,
} from "@mui/material";

import { FaCartPlus, FaShoppingCart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
    
    const navigate = useNavigate();

    const {
        id,
        nome,
        imagens,
        precos,
        descricao,
    } = product;

    const image = imagens?.[0] || "/placeholder.png";

    const isPromo = precos?.isPromo;
    const priceNormal = precos?.normal;
    const pricePromo = precos?.promo;

    const openProductPage = () => {
        navigate(`/produto/${id}`);
    };

    return (
        <Card
            onClick={openProductPage}
            sx={{
                width: "280px",
                minWidth: "280px",
                borderRadius: "20px",
                overflow: "hidden",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
                transition: "0.28s ease",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                position: "relative",

                "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 14px 32px rgba(0,0,0,0.18)",
                },
            }}
        >
            {/* Banner Promoção */}
            {isPromo && (
                <Chip
                    label="% Promoção"
                    sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        backgroundColor: "var(--azul)",
                        color: "white",
                        fontSize: 12,
                        height: 26,
                        borderRadius: "8px",
                        zIndex: 2,
                    }}
                />
            )}

            {/* IMAGEM */}
            <CardMedia
                component="img"
                src={image}
                alt={nome}
                sx={{
                    height: 210,
                    objectFit: "contain",
                    padding: 2,
                    background: "white",
                }}
            />

            {/* DIVISÓRIA */}
            <Box
                sx={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "#e2e2e2",
                }}
            />

            {/* CONTEÚDO */}
            <CardContent
                sx={{
                    paddingX: 3,
                    paddingBottom: 3,
                    flexGrow: 1,
                }}
            >
                {/* TÍTULO */}
                <Typography
                    sx={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: "var(--cinza)",
                        minHeight: "48px",
                        lineHeight: 1.3,
                    }}
                >
                    {nome}
                </Typography>

                {/* DESCRIÇÃO */}
                <Typography
                    sx={{
                        color: "#6f6f6f",
                        fontSize: 14,
                        mt: 0.5,
                        minHeight: "28px",
                    }}
                >
                    {descricao}
                </Typography>

                {/* PREÇO */}
                <Box
                    sx={{
                        minHeight: 50, // garante altura fixa para promo ou não
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        mt: 1.5,
                    }}
                >
                    {isPromo ? (
                        <>
                            <Typography
                                sx={{
                                    textDecoration: "line-through",
                                    color: "#999",
                                    fontSize: 14,
                                    lineHeight: 1.2,
                                }}
                            >
                                {priceNormal}
                            </Typography>

                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: 20,
                                    color: "var(--azul)",
                                    lineHeight: 1.2,
                                }}
                            >
                                {pricePromo}
                            </Typography>
                        </>
                    ) : (
                        <>
                            {/* linha fantasma para manter altura */}
                            <Typography
                                sx={{
                                    fontSize: 14,
                                    visibility: "hidden",
                                    lineHeight: 1.2,
                                }}
                            >
                                placeholder
                            </Typography>

                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: 20,
                                    color: "var(--azul)",
                                    lineHeight: 1.2,
                                }}
                            >
                                {priceNormal}
                            </Typography>
                        </>
                    )}
                </Box>

                {/* BOTÃO + FAVORITO */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        mt: 2,
                    }}
                >
                    <Button
                        fullWidth
                        sx={{
                            backgroundColor: "var(--azul)",
                            color: "white",
                            paddingY: 1,
                            fontWeight: 800,
                            borderRadius: "12px",
                            "&:hover": { backgroundColor: "#112040" },
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            openProductPage();
                        }}
                    >
                        COMPRAR
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProductCard;
